export const TourEndpoint = {
  GET_BY_USER: '/default/tour/get-by-user',
  SAVE: '/default/tour/save',
};
